import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { UserType } from '../../../enums/UserType';
import ProfileDefaultImage from '../../../images/profileDefault.png';
import CloseImage from '../../../images/close-cross.png';
import { Colors } from '../../../themes/colors';

export const JobDetailsUserBoxV2 = ({ user, style, textStyle, onCancel }) => {
  const profileType = user.user_type === UserType.DNT ? 'dental' : 'hygienist';
  const label = user.user_type === UserType.DNT ? 'Dental Office' : 'Dental Professional';
  const userId = user ? user.id : '';

  const address = useMemo(() => {
    if (!user?.address?.length || !user?.address[0]?.formatted_address) {
      return '';
    }
    const addressParts = user.address[0].formatted_address.split(', ');
    return `${addressParts[1]}, ${addressParts[2]}`;
  }, [user]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 20,
        ...style,
      }}
    >
      {user?.profile_image ? (
        <img
          src={user.profile_image}
          alt="profile"
          className="card-img-top mt-2 mb-2"
          style={{
            objectFit: 'cover',
            width: '100px',
            height: '100px',
            borderRadius: 50,
            boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.3)',
          }}
        />
      ) : (
        <img
          src={ProfileDefaultImage}
          alt="tooth"
          className="card-img-top mt-2 mb-2"
          style={{
            objectFit: 'cover',
            width: '100px',
            height: '100px',
            borderRadius: 50,
            boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.3)',
          }}
        />
      )}
      {user ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            ...textStyle,
          }}
        >
          <strong className="card-title" style={{ color: Colors.secondary_500 }}>
            {label}
          </strong>

          <p className="f-18 card-text">
            {user.user_type === UserType.DNT
              ? user?.office_name
              : `${user.first_name} ${user.last_name}`}{' '}
            - {address}
          </p>

          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <Link
              className="card-text"
              to={{
                pathname: `/user/${profileType.toLowerCase()}/${userId}`,
                state: {
                  user_id: userId,
                  profile: profileType,
                },
              }}
            >
              View Profile
            </Link>
            {onCancel && (
              <img
                alt="icon"
                src={CloseImage}
                style={{ width: 16, height: 16, cursor: 'pointer' }}
                onClick={() => {
                  onCancel();
                }}
              />
            )}
          </div>
        </div>
      ) : (
        <div>
          <h3 className="card-title">Not yet filled</h3>
        </div>
      )}
    </div>
  );
};
